import { render, staticRenderFns } from "./UnstyledText.vue?vue&type=template&id=33642fb8&scoped=true"
import script from "./UnstyledText.vue?vue&type=script&lang=js"
export * from "./UnstyledText.vue?vue&type=script&lang=js"
import style0 from "./UnstyledText.vue?vue&type=style&index=0&id=33642fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33642fb8",
  null
  
)

export default component.exports